var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "modal" } }, [
    _c("div", { staticClass: "modal-mask" }, [
      _c("div", { staticClass: "modal-wrapper" }, [
        _c(
          "div",
          {
            staticClass: "modal-container modal-container-80",
            on: {
              mousedown: function ($event) {
                $event.stopPropagation()
              },
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "modal-body m-0",
                staticStyle: { "overflow-y": "auto" },
                style: { maxHeight: _vm.getMaxHeightClient() + "px" },
              },
              [
                _vm.isScanQRCodeActive
                  ? _c(
                      "div",
                      [
                        _c(
                          "qr-code-stream",
                          {
                            key: _vm._uid,
                            attrs: {
                              track: _vm.trackingQRCode,
                              camera: _vm.camera,
                            },
                            on: { decode: _vm.onDecode, init: _vm.onInit },
                          },
                          [
                            _vm.scanningEnd
                              ? _c("div", { staticClass: "scan-end" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t(
                                          "creation_forms.scn_qr_code_sccs"
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.scanningPending
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "center scan-pending text-center",
                                  },
                                  [
                                    _c("b-spinner"),
                                    _vm._v(" "),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "creation_forms.scn_qr_code_pndg"
                                          )
                                        )
                                      ),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.loading
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "center text-center scan-pending",
                                  },
                                  [
                                    _c("b-spinner"),
                                    _vm._v(" "),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "creation_forms.scn_qr_code_ldng"
                                          )
                                        )
                                      ),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.errorNoCamera
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "center text-center scan-pending",
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "fa-stack fa-2x" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fa fa-camera fa-stack-1x",
                                        }),
                                        _vm._v(" "),
                                        _c("i", {
                                          staticClass:
                                            "fa fa-ban fa-stack-2x text-danger",
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "strong",
                                      { staticClass: "text-danger" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("errors.no_camera"))
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "button-action firstButtonMarginTop",
                    attrs: { round: "" },
                    on: {
                      click: function ($event) {
                        return _vm.quitScanner()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.cncl")))]
                ),
              ]
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }